import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { MiniModeService, miniModeLandingRoute, routeKeyForPath } from '../services/mini-mode.service';

export const miniModeGuard: CanActivateFn = (_route, state) => {
  const miniModeService = inject(MiniModeService);
  const router = inject(Router);

  if (!miniModeService.isMiniMode()) return true;
  return miniModeService.getProfile().pipe(
    map((profile) => {
      const path = state.url.split('?')[0];
      const key = routeKeyForPath(path);
      if (path === '/' && key === 'dashboard') return router.parseUrl(miniModeLandingRoute(profile.miniModePageKeys));
      return profile.miniModePageKeys.includes(key ?? '') ? true : router.parseUrl('/notfound?mode=mini');
    }),
    catchError(() => of(router.parseUrl('/notfound?mode=mini')))
  );
};
